"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCapabilityList = getCapabilityList;
const baseUrls_1 = require("./baseUrls");
async function getCapabilityList() {
    try {
        const response = await fetch(`${baseUrls_1.GigsApiBaseUrl}/getCapabilityList`);
        return await response.json();
    }
    catch (error) {
        console.error("Error fetching capabilities:", error);
        return [];
    }
}
